import React, { useState, useEffect } from 'react';
import { getDatabase, ref, onValue } from 'firebase/database';
import app from '../../firebase';
import { Mail, Phone, MapPin, User } from 'lucide-react';

const db = getDatabase(app);

const ContractorRequests = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const contractorId = localStorage.getItem('contractorId');

  useEffect(() => {
    if (!contractorId) return;

    const requestsRef = ref(db, `Contractors/${contractorId}/newRequests`);
    
    const unsubscribe = onValue(requestsRef, (snapshot) => {
      const data = snapshot.val();
      const requestsArray = [];
      
      if (data) {
        Object.keys(data).forEach(key => {
          requestsArray.push({
            id: key,
            ...data[key]
          });
        });
        // Sort by timestamp (newest first)
        requestsArray.sort((a, b) => b.timestamp - a.timestamp);
      }
      
      setRequests(requestsArray);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [contractorId]);

  const handlePhoneClick = (phoneNumber) => {
    window.location.href = `tel:${phoneNumber}`;
  };

  if (!contractorId) {
    return (
      <div className="p-4 text-center text-gray-600">
        Please login to view requests
      </div>
    );
  }

  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold mb-4">Customer Requests</h2>
      
      {loading ? (
        <div className="flex justify-center items-center h-40">
          <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-amber-500"></div>
        </div>
      ) : requests.length === 0 ? (
        <div className="text-center py-8 text-gray-500">
          No requests found
        </div>
      ) : (
        <div className="space-y-3">
          {requests.map(request => (
            <div key={request.id} className="border rounded-lg p-4 bg-white shadow-sm">
              <div className="flex items-start gap-3">
                <div className="bg-amber-100 p-2 rounded-full">
                  <User className="w-5 h-5 text-amber-600" />
                </div>
                <div className="flex-1">
                  <h3 className="font-medium">{request.userName}</h3>
                  <div className="mt-2 space-y-2">
                    <div className="flex items-center">
                      <button 
                        onClick={() => handlePhoneClick(request.userPhone)}
                        className="flex items-center text-blue-600 hover:text-blue-800"
                      >
                        <Phone className="w-4 h-4 mr-2" />
                        {request.userPhone}
                      </button>
                    </div>
                    {request.userEmail && (
                      <div className="flex items-center">
                        <a 
                          href={`mailto:${request.userEmail}`}
                          className="flex items-center text-blue-600 hover:text-blue-800"
                        >
                          <Mail className="w-4 h-4 mr-2" />
                          {request.userEmail}
                        </a>
                      </div>
                    )}
                    {request.userLocation?.address && (
                      <div className="flex items-center text-gray-600">
                        <MapPin className="w-4 h-4 mr-2 flex-shrink-0" />
                        <span>{request.userLocation.address}</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ContractorRequests;